import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { SEO } from "gatsby-theme-core";
import { Layout, HeaderOne, FooterOne } from "gatsby-theme-layout";
import { BannerSection } from "gatsby-theme-container";

const StreamingIndex = ({ data }) => (
    <Layout>
        <SEO pageName="Horror Series" />
        <HeaderOne data={{ ...data?.header, ...data.navigation }} />
        <BannerSection
            data={{
                items: data?.horrorSeriesBanner?.nodes,
            }}
        />
        <FooterOne data={{ ...data?.footer, ...data?.contact }} />
    </Layout>
);

export const query = graphql`
    query StreamingHorrorSeriesQuery {
        header: general(section: { eq: "header-01" }) {
            ...Header01
        }
        navigation: general(section: { eq: "menu-streaming" }) {
            ...Menu01
        }
        footer: general(section: { eq: "footer-01" }) {
            ...Footer01
        }
        contact: general(section: { eq: "contact" }) {
            ...Contact01
        }
        page(title: { eq: "streaming-home-two" }) {
            content {
                ...PageContent
            }
        }
        horrorSeriesBanner: allVideoStreamingSeries(
            sort: { fields: date, order: DESC }
            filter: {
                category: { elemMatch: { slug: { eq: "horror" } } }
                is_featured: { eq: true }
            }
        ) {
            nodes {
                ...VideoStreamingSeries
            }
        }
    }
`;

StreamingIndex.propTypes = {
    data: PropTypes.shape({
        header: PropTypes.shape({}),
        navigation: PropTypes.shape({}),
        footer: PropTypes.shape({}),
        contact: PropTypes.shape({}),
        page: PropTypes.shape({
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        featuredMoviesPost: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        allLatestMoviesPost: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        allVideoStreamingHorrorSeries: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        allOldMoviesPost: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        allVideoStreamingFamilyMovie: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        horrorSeriesBanner: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        awardWinningMovie: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};
export default StreamingIndex;
